import React, { useEffect } from "react";
import { Router, useNavigate } from "@reach/router";
import { useAuth } from "../context/AuthContext";
import Login from "./Login";
import Home from "./Home";
import Header from "./Header";
import NavBar from "./NavBar";
import Users from "./Users";
import Drinks from "./Drinks";
import Styles from "./Styles";
import Categories from "./Categories";
import Attributes from "./Attributes";
import Traits from "./Traits";


const Root = (props) => {
  const { testAuth } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    const test = async () => {
      try {
        await testAuth();
      } catch (e) {
        navigate("/login");
      }
    };
    test();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Header />
      <NavBar />
      <div id="content">{props.children}</div>
    </>
  );
};

const App = () => (
  <Router>
    <Login path="/login" />
    <Root path="/" primary={false}>
      <Home path="/" />
      <Users path="/users" />
      <Drinks path="/drinks" />
      <Styles path="/styles" />
      <Categories path="/categories" />
      <Attributes path="/attributes" />
      <Traits path="/traits" />
    </Root>
  </Router>
);

export default App;
